import { render, staticRenderFns } from "./AddHot.vue?vue&type=template&id=527b4edb&scoped=true&"
import script from "./AddHot.vue?vue&type=script&lang=js&"
export * from "./AddHot.vue?vue&type=script&lang=js&"
import style0 from "./AddHot.vue?vue&type=style&index=0&id=527b4edb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527b4edb",
  null
  
)

export default component.exports